import { useEffect, useState } from 'react';
import type { DesktopBridge } from '../fileSave';

/** Desktop app only: shows whether recipes are on this PC or on your server, and lets you change it. */
export function ConnectionCard() {
  const bridge = window.muddleDesktop;
  const [conn, setConn] = useState<{ serverUrl: string | null } | null>(null);
  const [backup, setBackup] = useState<Awaited<ReturnType<DesktopBridge['getLocalBackup']>> | null>(
    null,
  );
  useEffect(() => {
    void bridge?.getConnection().then(setConn, () => setConn(null));
    void bridge?.getLocalBackup().then(setBackup, () => setBackup(null));
  }, [bridge]);
  if (!bridge || !conn) return null;
  return (
    <section className="card" aria-labelledby="conn-title">
      <h2 className="card-title" id="conn-title">
        Where your recipes live
      </h2>
      <p className="card-sub">
        {conn.serverUrl
          ? 'This app shows the recipes stored on your server, the same ones your phone and the website show.'
          : 'Recipes are stored on this PC only. Connect to your server to share one database with your phone.'}
      </p>
      <div className="list-row">
        <span>Stored on</span>
        <span>{conn.serverUrl ?? 'This PC'}</span>
      </div>
      {conn.serverUrl && backup?.enabled && (
        <>
          <div className="list-row">
            <span>Automatic copy on this PC</span>
            <span>
              {backup.last
                ? `${backup.last.status === 'saved' ? 'Saved' : 'Up to date'} ${new Date(backup.last.at).toLocaleString()}`
                : 'Made each time you open Muddle and sign in'}
            </span>
          </div>
          <div className="list-row">
            <span>Kept in</span>
            <span className="num">
              {backup.dir} ({backup.count} of {backup.keep})
            </span>
          </div>
        </>
      )}
      <div className="actions">
        {conn.serverUrl && backup?.enabled && (
          <button
            className="btn btn-ghost"
            type="button"
            onClick={() => void bridge.openBackupFolder()}
          >
            Open backup folder
          </button>
        )}
        <button
          className="btn btn-ghost"
          type="button"
          onClick={() => void bridge.openConnection()}
        >
          {conn.serverUrl ? 'Change connection…' : 'Connect to a server…'}
        </button>
      </div>
    </section>
  );
}
